/**
 * Rend visible l'échec de chargement des données qui alimentent les documents
 * de transport (arrêts, produits du CMR).
 *
 * ---------------------------------------------------------------------------
 * POURQUOI CE MIXIN EXISTE
 * ---------------------------------------------------------------------------
 * Le 2026-08-17, `/getroutetransportv2/:id` renvoyait 500 pour TOUS les
 * transports (un paramètre nommé Sequelize oublié dans un commentaire SQL, cf.
 * api/scripts/check-sql-named-params.js). Côté écran, les trois chargeurs
 * avaient un `catch` muet qui remettait simplement la liste à `[]` :
 *
 *   .catch(() => { this.routetransport = [] })
 *
 * Conséquence : le bouton RECEPTION passait rouge en disant « Please generate
 * Final Invoice with address » — un message qui désignait la mauvaise cause —
 * et le CMR sortait en PDF entièrement blanc, parce que les générateurs bouclent
 * sur `routetransport.length`. Aucune trace à l'écran, aucune alerte : deux
 * heures pour retrouver un commentaire.
 *
 * L'API en échec n'est pas rattrapable côté front. Ce qui est rattrapable, c'est
 * de le DIRE : le prochain incident du même genre doit se lire sur la page.
 *
 * Prérequis : le composant affiche `loadErrors` (voir le vs-alert des écrans
 * transport) et appelle `reportLoadError()` dans chacun de ses catch.
 */
export default {
  data () {
    return {
      /** [{ key, label, detail }] — un par source de données en échec. */
      loadErrors: []
    }
  },
  computed: {
    /** Vrai dès qu'une source nécessaire aux documents n'a pas pu être lue. */
    dataLoadFailed () {
      return this.loadErrors.length > 0
    }
  },
  methods: {
    /**
     * À appeler dans le catch d'un chargeur.
     *
     * @param {string} key    identifiant stable de la source (dédoublonnage)
     * @param {string} label  ce que l'utilisateur perd, en clair
     * @param {Error}  error  l'erreur axios
     */
    reportLoadError (key, label, error) {
      const response = error && error.response
      const data = response && response.data
      // L'API renvoie { message } sur ses erreurs gérées ; sinon on se rabat sur
      // le statut HTTP, puis sur le message JS. Jamais "undefined" à l'écran.
      const detail =
        (data && (data.message || data.error)) ||
        (response && response.status ? 'HTTP ' + response.status : null) ||
        (error && error.message) ||
        'unknown error'

      console.error('[' + key + '] ' + label + ' : ', error)

      // Un seul enregistrement par source, même si le chargeur est rejoué.
      const existing = this.loadErrors.findIndex((item) => item.key === key)
      const entry = { key, label, detail }
      if (existing === -1) this.loadErrors.push(entry)
      else this.loadErrors.splice(existing, 1, entry)

      this.$vs.notify({
        color: 'danger',
        title: 'Data not loaded — documents will be incomplete',
        text: label + ' : ' + detail,
        time: 15000
      })
    }
  }
}
